var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PeriodPicker',{attrs:{"frequencyLabel":"Pay Frequency","periodLabel":"Period","frequencyId":_vm.payFrequencyId,"dateBegin":_vm.dateBegin,"dateEnd":_vm.dateEnd,"deriveCurrentPeriodOnMount":true},on:{"frequencyChange":_vm.frequencyChangeHandler,"periodChange":_vm.periodChangeHandler}})
}
var staticRenderFns = []

export { render, staticRenderFns }